import React from "react";
import styles from "./scan-loading-linear-indicator.module.scss";

export const ScanLoadingLinearIndicator = () => {
  return (
    <div className={styles["linear-indicator"]}>
      <span className={styles["linear-indicator__progress-bar-1"]} />
      <span className={styles["linear-indicator__progress-bar-2"]} />
    </div>
  );
};
